<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head"><a id="page_x"></a>O<span class="smallcaps">THER</span> B<span class="smallcaps">OOKS BY</span> M<span class="smallcaps">ALCOLM</span> H<span class="smallcaps">AY</span></p>
<p class="fm-para"><em>Wounded and a Prisoner of War</em>     1916</p>
<p class="fm-para"><em>A Chain of Error in Scottish History</em>     1927</p>
<p class="fm-para"><em>The Blairs Papers (1603–1660)</em>     1929</p>
<p class="fm-para"><em>The Jesuits and the Popish Plot</em>     1934</p>
<p class="fm-para"><em>Winston Churchill and James II</em>     1934</p>
<p class="fm-para"><em>The Enigma of James II</em>     1938</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007_FM1.vue?754df2b6